/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxCheckSumsTabAction,
    CashBoxCheckSumsTabActionType,
    fetchCheckSumsHistorySuccessAction,
    fetchCheckSumsHistoryErrorAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxCheckSumsTabActions';
import { parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const fetchCashBoxCheckSumsHistoryEpic: Epic<CashBoxCheckSumsTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxCheckSumsTabActionType.FETCH_CHECKSUMS_HISTORY),
        switchMap((action) => {
            const params = action.payload;
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const listName = i18n.t('RegistryScreens.checkSumHistory').toLocaleLowerCase();

            return from(cashboxesClient.getCheckSumsHistory(taxNumber, params)).pipe(
                map((resp) => {
                    return fetchCheckSumsHistorySuccessAction(resp);
                }),
                catchError((err: AxiosError) =>
                    of(
                        fetchCheckSumsHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(CashBoxCheckSumsTabActionType.EXIT_CASHBOX_CHECKSUMS_TAB)),
            );
        }),
    );
};
